import { CheckCircle2, Shield } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

// Small inline badge for listings and chat
export function VerifiedBadge({ size = "sm", showTooltip = true }) {
  const sizeClasses = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6"
  };

  const badge = (
    <span className="inline-flex items-center">
      <CheckCircle2 className={`${sizeClasses[size]} text-green-500`} />
    </span>
  );

  if (!showTooltip) return badge;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {badge}
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-xs">Verified User</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

// Full badge with text for profiles
export function VerifiedBadgeFull({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 bg-green-100 text-green-700 rounded-full text-xs font-medium ${className}`}>
      <CheckCircle2 className="w-3 h-3" />
      Verified
    </span>
  );
}

// Unverified badge with action prompt
export function UnverifiedBadge({ onClick, className = "" }) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1 px-2 py-0.5 bg-amber-100 text-amber-700 rounded-full text-xs font-medium hover:bg-amber-200 transition-colors ${className}`}
    >
      <Shield className="w-3 h-3" />
      Verify Now
    </button>
  );
}

// Status indicator for dashboard/profile
export function VerificationStatus({ isVerified, onVerify }) {
  if (isVerified) {
    return (
      <div className="flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg">
        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
          <CheckCircle2 className="w-5 h-5 text-green-600" />
        </div>
        <div>
          <p className="text-sm font-medium text-green-800">Mobile Verified</p>
          <p className="text-xs text-green-600">Your account has a verified badge</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between p-3 bg-amber-50 border border-amber-200 rounded-lg">
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center">
          <Shield className="w-5 h-5 text-amber-600" />
        </div>
        <div>
          <p className="text-sm font-medium text-amber-800">Unverified Account</p>
          <p className="text-xs text-amber-600">Verify to get a trusted badge</p>
        </div>
      </div>
      <button
        onClick={onVerify}
        className="px-3 py-1.5 bg-orange-500 text-white text-sm font-medium rounded-lg hover:bg-orange-600 transition-colors"
      >
        Verify Now
      </button>
    </div>
  );
}

export default VerifiedBadge;
